<template>

<div id="tab">

<div class="nav-wrapper grid">
    <nav class="nav-container content">  
        <router-link to="/about"><p class="small-text">Про проєкт</p></router-link>
        <router-link to="/"><p class="small-text">Порушення благоустрою</p></router-link>
        <router-link to="/mafy"><p class="small-text">Тимчасові споруди</p></router-link>
        <router-link to="/ads"><p class="small-text">Рекламні конструкції</p></router-link>
        
        <div class="share-buttons">
            <a class="share-btn fb-button" href="https://www.facebook.com/sharer/sharer.php?u=https://texty.org.ua/d/2020/slovjansk/">
                <img src="../assets/fb-button.svg">
            </a>

            <a class="share-btn twitter-button" href="https://twitter.com/intent/tweet?text=https://texty.org.ua/d/2020/slovjansk/">
                <img src="../assets/twitter-button.svg">
            </a>
        </div>
    </nav>
</div>

<main :class="`tab-${$route.name}`" style="margin-top: 4em;">
    <slot> 

    </slot>
</main>

<footer class="grid" >
    <texty-footer class="content" share_url="https://texty.org.ua/d/2020/slovjansk/"/>
</footer>

</div>
</template>

<script>
import TextyFooter from "../components/other/footer/TextyFooter"

export default {
    name: "Tab",
    components: {
        TextyFooter
    },

    data() {
        return {
            dimensions: {
                width: 0,
                orientation: 'landscape'
            }
        }
    },

    mounted() {
        this.$nextTick(function(){
            this.onresize()
            this.onorientationchange()
            window.addEventListener("resize", this.onresize)
            window.addEventListener("orientationchange", this.onorientationchange)
        })
    },

    destroyed() {
        window.removeEventListener("resize", this.onresize)
        window.removeEventListener("orientationchange", this.onorientationchange)
    },
    
    methods: {
        onresize(e) {
            this.dimensions.width = this.$el.offsetWidth
        },

        onorientationchange(e) {
            const orientation = window.screen.orientation.type
            
            if (orientation === "portrait-primary") {
                this.dimensions.orientation = 'portrait'
            } else {
                this.dimensions.orientation = 'landscape'
            }
        }
    },

    watch: {
        'dimensions': {
            handler: function(after, before) {
                console.log('emit')
                this.$emit("dimensions_changed", this.dimensions)
            },
            deep: true,
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/base/variables';

main {
    min-height: 100vh;

    > * {
        transition: all 0.25s ease-out;
    }
}

.top-hr {
    margin-bottom: 1em;
}

.nav-wrapper {
    position: sticky;
    width: 100%;
    background-color: white;
    top: 0;
    z-index: 1001;
}

nav {
    display: flex;
    flex-flow: row;
    gap: 3em;
    align-items: center;
    height: 50px;
    // border: 1px solid black;
    border-bottom: 2px solid black;
    > a {
        p {
            margin-bottom: 0;
        }

        &:hover, &:focus
        // &.router-link-exact-active 
        {
            p {
                border-bottom: 2px solid black;
            }
        }
    }

    @media screen and (max-width: $sz-mobile) {
        p {
            font-size: 0.7em !important;
        }

        gap: 0.5em;
    }

    hr {
        margin-top: 2em;
        margin-bottom: 2em;
    }
}

.content-2 .main-text {
    padding-left: 2em;
    padding-right: 6em;
}


.panel-above-map {
    position: absolute;
    z-index: 1000;
    margin: 0.7em;
}

/deep/ .sticky-container {
    min-height: 100%;

    .sticky-content {
        position: sticky !important;
        top: 0;
    }
}

.map-loading {
    height: 65vh;
    min-height: 400px;
    display: flex;

    justify-content: center;
    align-items: center;

    // p {
    //     font-size: 2em;
    //     font-weight: 300;
    // }
}

hr {
    border: 0;
    height: 2px;
    background: #333;
}

.informer-stripe {
    padding: 3em 0;

    h1, h4 {
        margin-bottom: 0.2em;
    }

    .informer-box {
        max-width: 25em;
    }
}

footer {
    background: #000;
}

.share-buttons {
    margin-left: auto;
    display: flex;
    gap: 0.7em;
}


@media screen and (max-width: $sz-mobile){ 
    // .informer-stripe {
    //     .informer-box {
    //         max-width:
    //     }
    // }
}

</style>